import React from 'react'
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import aboutBanner from '../assests/img/header-banner.jpg';
import letter1 from '../assests/img/legal-1.jpg';
import letter2 from '../assests/img/legal-2.jpg';
import letter3 from '../assests/img/legal-3.jpg';
import letter4 from '../assests/img/legal-4.jpg';
import letter5 from '../assests/img/legal-5.png';
import letter6 from '../assests/img/legal-6.jpg';
import { Helmet } from 'react-helmet-async';


import 'photoswipe/dist/photoswipe.css'

import { Gallery, Item } from 'react-photoswipe-gallery'

function Legalization() {
  return (
    <div >

      <Helmet>
        <title>Legalization | State Board of Secondary Education, Delhi</title>
        <meta
          name="description"
          content="Learn more about the State Board of Secondary Education, Delhi, and its initiatives to promote education and literacy."
        />
        <meta
          name="keywords"
          content="State Board of Secondary Education, Delhi, education, literacy, initiatives"
        />
      </Helmet>

      <Header />

      <div className='container'>
        <div className='about-banner'>
          <img src={aboutBanner} alt="" />
          <h1 className='page-title'>Legalization</h1>
        </div>
      </div>

      <div className='container main-contant'>
        <div className='inner-page-container gallery-page-container'>          

          <Gallery>
            <Item
              className="gallery-item"              
              original={letter1}
              thumbnail={letter1}
              width="1275"
              height="1750"
            >
              {({ ref, open }) => (
                <img ref={ref} onClick={open} src={letter1} />
              )}
            </Item>
            <Item
              className="gallery-item"
              original={letter2}
              thumbnail={letter2}
              width="1275"
              height="1750"
            >
              {({ ref, open }) => (
                <img ref={ref} onClick={open} src={letter2} />
              )}
            </Item>
            <Item
              className="gallery-item"
              original={letter3}
              thumbnail={letter3}
              width="1275"
              height="1750"
            >
              {({ ref, open }) => (
                <img ref={ref} onClick={open} src={letter3} />
              )}
            </Item>
           <Item
              className="gallery-item"
              original={letter4}
              thumbnail={letter4}
              width="1275"
              height="1750"
            >
              {({ ref, open }) => (
                <img ref={ref} onClick={open} src={letter4} />
              )}
            </Item>
             <Item
              className="gallery-item"
              original={letter5}
              thumbnail={letter5}
              width="1275"
              height="1750"
            >
              {({ ref, open }) => (
                <img ref={ref} onClick={open} src={letter5} />
              )}
            </Item>
             <Item
              className="gallery-item"
              original={letter6}
              thumbnail={letter6}
              width="1275"
              height="1750"
            >
              {({ ref, open }) => (
                <img ref={ref} onClick={open} src={letter6} />
              )}
            </Item>            
          </Gallery>
        </div>

      </div>
      <Footer />
    </div>
  )
}

export default Legalization;
